import { render, staticRenderFns } from "./CreditTab.vue?vue&type=template&id=1389ff94&scoped=true&"
import script from "./CreditTab.vue?vue&type=script&lang=js&"
export * from "./CreditTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1389ff94",
  null
  
)

export default component.exports